/**
 * Byte-identical port of the AngularJS `parse` filter (account-v1/src/core/parse/parse.js),
 * which delegates to the pure `ParseService`. Used by the contest-sheets + story-modal local
 * `parse` pipes (`value | parse:'number'|'bool'|'array'[:defaultValue]`) so the frozen-baseline
 * read-views match character-for-character off the `$filter('parse')` bridge.
 *
 * ⚠ Deliberately NOT the libs/shared `Parse`/`ParseUtil`: that one diverges from v1
 * (`intOrDefault` uses `defaultValue || 0` where v1 uses `defaultValue !== undefined ? defaultValue : 0`,
 * and `.toString()` throws on null/undefined where v1 `parseInt(null,10)` is NaN→0). This mirrors
 * v1 EXACTLY: `parseInt(text,10)` (no `.toString()`), the `!== undefined` default guard, the
 * `arrayOrDefault` item/datum unwrap, and the `=== true || == '1' || === 'true'` bool. Proven by
 * account-parity/_diag-parse-check.mjs (LIVE `$filter('parse')` vs native).
 */
export function parseValue(text: any, type?: string, defaultValue?: any): any {
  if (type === 'number') {
    const parsed = parseInt(text, 10);
    if (!isNaN(parsed)) return parsed;
    return typeof defaultValue !== 'undefined' ? defaultValue : 0;
  }
  if (type === 'array') {
    if (!text) return [];
    if (Array.isArray(text)) return text;
    if (Array.isArray(text.item)) return text.item;
    if (Array.isArray(text.datum)) return text.datum;
    return [text];
  }
  if (type === 'bool') {
    return text === true || text == '1' || text === 'true';
  }
  return undefined;
}
